(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["uhp-gels-autumn"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('uhp-gels')){customElements.define('uhp-gels',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.cards=[...this.querySelectorAll('[data-gel]')];this.counts=this.cards.map(()=>0);this.strings=JSON.parse(this.querySelector('[data-strings]').textContent);this.dialog=this.querySelector('dialog');this.money=new Intl.NumberFormat('nb-NO',{style:'currency',currency:this.dataset.currency||'NOK',minimumFractionDigits:0,maximumFractionDigits:2});this.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',()=>this.dialog.close()));this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});this.cards.forEach((card,i)=>card.querySelectorAll('[data-step]').forEach(b=>b.addEventListener('click',()=>{const next=this.counts[i]+Number(b.dataset.step);if(next<0)return;if(this.counts.reduce((a,n)=>a+n,0)+Number(b.dataset.step)>3){this.status(this.strings.limit);return;}this.counts[i]=next;this.status('');this.refresh();})));this.querySelector('[data-add-selection]').addEventListener('click',e=>{const rows=this.rows();const total=this.offerTotal(rows);this.add(rows,total,e.currentTarget);});this.querySelectorAll('[data-single]').forEach(b=>b.addEventListener('click',()=>this.add([{id:b.dataset.variant,quantity:1,name:b.dataset.name,price:Number(b.dataset.price)}],Number(b.dataset.price),b)));this.querySelector('[data-warm-duo]').addEventListener('click',e=>{const c=this.cards[0];this.add([{id:c.dataset.variant,quantity:2,name:c.dataset.name,price:Number(c.dataset.price)}],69900,e.currentTarget);});this.querySelector('[data-home]').addEventListener('click',e=>this.add([{id:e.currentTarget.dataset.variant,quantity:1,name:this.strings.home+' · '+this.strings.home_description,price:42000}],42000,e.currentTarget));this.refresh();}
status(text){this.querySelector('[data-status]').textContent=text;}
rows(){return this.cards.map((c,i)=>({id:c.dataset.variant,quantity:this.counts[i],name:c.dataset.name,price:Number(c.dataset.price)})).filter(r=>r.quantity>0);}
offerTotal(rows){const count=rows.reduce((a,r)=>a+r.quantity,0);return rows.reduce((a,r)=>a+r.quantity*r.price,0)-Math.max(0,Math.min(count,3)-1)*6100;}
refresh(){const rows=this.rows(),count=this.counts.reduce((a,n)=>a+n,0);this.cards.forEach((c,i)=>{c.querySelector('[data-count]').textContent=this.counts[i];c.querySelector('[data-step="-1"]').disabled=this.counts[i]===0;c.querySelector('[data-step="1"]').disabled=count>=3||c.dataset.available!=='true';});this.querySelector('[data-selection]').hidden=count===0;this.querySelector('[data-selected-summary]').textContent=this.strings.selected.replace('[count]',count);this.querySelector('[data-selected-price]').textContent=this.money.format(this.offerTotal(rows)/100);this.querySelector('[data-savings]').textContent=count>1?this.strings.save.replace('[amount]',this.money.format((count-1)*61)):'';}
async add(rows,total,button){if(!rows.length)return;this.status('');if(this.dataset.preview==='true'){const list=this.querySelector('[data-dialog-items]');list.replaceChildren();rows.forEach(r=>{const div=document.createElement('div');div.className='uhp-gels__dialog-row';const label=document.createElement('span');label.textContent=r.quantity+' × '+r.name;div.append(label);list.append(div);});this.querySelector('[data-dialog-total]').textContent=this.money.format(total/100);this.dialog.showModal();return;}if(rows.some(r=>!r.id)){this.status(this.strings.error);return;}button.disabled=true;try{const result=await fetch(this.dataset.addUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:rows.map(r=>({id:Number(r.id),quantity:r.quantity}))})});const payload=await result.json();if(!result.ok)throw new Error(payload.description||this.strings.error);window.location.assign(this.dataset.cartUrl);}catch(e){this.status(e.message||this.strings.error);button.disabled=false;}}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uhp-gels-ui"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('uhp-gels-ui')) {
  customElements.define('uhp-gels-ui', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.mode = this.dataset.mode;
      this.preview = this.dataset.preview !== 'false';
      this.cards = [...this.querySelectorAll('[data-gel]')];
      this.counts = this.cards.map(() => 0);
      this.cart = new Map();
      this.strings = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.warmIds = JSON.parse(this.querySelector('[data-warm-ids]').textContent);
      this.cartDialog = this.querySelector('[data-cart-dialog]');
      this.sizeDialog = this.querySelector('[data-size-dialog]');
      this.money = new Intl.NumberFormat('nb-NO', {style:'currency',currency:this.dataset.currency || 'NOK',minimumFractionDigits:0,maximumFractionDigits:2});
      this.querySelectorAll('[data-close]').forEach(b => b.addEventListener('click', () => b.closest('dialog').close()));
      this.querySelectorAll('dialog').forEach(d => d.addEventListener('click', e => {
        if (e.target !== d) return;
        const r = d.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
      }));
      this.cards.forEach((card,i) => {
        card.querySelector('[data-direct-add]')?.addEventListener('click', () => this.addRows([this.cardRow(card)]));
        card.querySelectorAll('[data-step]').forEach(b => b.addEventListener('click', () => {
          const step = Number(b.dataset.step);
          if (this.counts[i] + step < 0) return;
          if (this.counts.reduce((a,n) => a+n,0) + step > 3) {this.status(this.strings.limit);return;}
          this.counts[i] += step;
          this.status(''); this.refresh();
        }));
      });
      this.galleryResize = new ResizeObserver(entries => entries.forEach(entry => entry.target.dispatchEvent(new Event('scroll'))));
      this.querySelectorAll('[data-gallery]').forEach(gallery => {
        const track = gallery.querySelector('[data-gallery-track]');
        let gesture = null;
        let suppressClickUntil = 0;
        track.addEventListener('pointerdown', event => {
          gesture = {x:event.clientX, y:event.clientY, scroll:track.scrollLeft, moved:false};
        }, {passive:true});
        track.addEventListener('pointermove', event => {
          if (gesture && (Math.abs(event.clientX - gesture.x) > 10 || Math.abs(event.clientY - gesture.y) > 10)) gesture.moved = true;
        }, {passive:true});
        track.addEventListener('pointerup', () => {
          if (gesture && (gesture.moved || Math.abs(track.scrollLeft - gesture.scroll) > 5)) suppressClickUntil = Date.now() + 400;
          gesture = null;
        }, {passive:true});
        track.addEventListener('pointercancel', () => {gesture = null; suppressClickUntil = Date.now() + 400;}, {passive:true});
        track.addEventListener('click', event => {
          if (Date.now() < suppressClickUntil) {event.preventDefault(); event.stopPropagation();}
        }, true);
        track.addEventListener('dragstart', event => event.preventDefault());
        const controls = gallery.querySelector('[data-gallery-controls]');
        if (!controls) return;
        const count = track.children.length;
        const counter = gallery.querySelector('[data-gallery-count]');
        const previous = gallery.querySelector('[data-gallery-step="-1"]');
        const next = gallery.querySelector('[data-gallery-step="1"]');
        const index = () => Math.max(0, Math.min(count - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));
        const sync = () => {
          const current = index();
          counter.textContent = (current + 1) + ' / ' + count;
          previous.disabled = current === 0;
          next.disabled = current === count - 1;
        };
        const move = step => {
          const target = Math.max(0, Math.min(count - 1, index() + step));
          track.scrollTo({left:target * track.clientWidth, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        };
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
        });
        track.addEventListener('scroll', sync, {passive:true});
        this.galleryResize.observe(track);
        controls.hidden = false;
        sync();
      });
      this.querySelectorAll('[data-open-size]').forEach(b => b.addEventListener('click', () => {
        this.sizeDialog.querySelectorAll('[data-size-choice]').forEach(r => r.checked = false);
        this.chosenSize = null;
        const confirm = this.querySelector('[data-confirm-size]'); confirm.disabled = true; confirm.textContent = this.strings.choose_first;
        this.sizeDialog.showModal();
      }));
      this.querySelectorAll('[data-size-choice]').forEach(r => r.addEventListener('change', () => {
        this.chosenSize = {id:r.value,quantity:1,name:this.cards[0].dataset.name+' · '+r.dataset.size,price:Number(r.dataset.price),eligible:r.value===this.cards[0].dataset.variant};
        const confirm = this.querySelector('[data-confirm-size]'); confirm.disabled = false;
        confirm.textContent = this.strings.add_cart+' · '+this.format(this.chosenSize.price);
      }));
      this.querySelector('[data-confirm-size]').addEventListener('click', () => {
        if (!this.chosenSize) return;
        this.sizeDialog.close(); this.addRows([this.chosenSize]);
      });
      this.querySelector('[data-primary-action]').addEventListener('click', async () => {
        if (this.busy) return;
        if (this.mode === 'builder' && this.counts.some(n => n > 0)) {
          if (!await this.addRows(this.selectionRows())) return;
          this.counts.fill(0);
          if (!this.preview) return;
          this.refresh();
        }
        this.openCart();
      });
      this.querySelectorAll('[data-single]').forEach(b => b.addEventListener('click', async () => {
        const added = await this.addRows([{id:b.dataset.variant,quantity:1,name:b.dataset.name,price:Number(b.dataset.price),eligible:false}]);
        if (added && this.preview && this.mode === 'builder') this.openCart();
      }));
      this.querySelector('[data-warm-duo]').addEventListener('click', async () => {
        const added = await this.addRows([this.cardRow(this.cards[0],2)]);
        if (added && this.preview && this.mode === 'builder') this.openCart();
      });
      this.querySelector('[data-home]').addEventListener('click', async event => {
        const button = event.currentTarget;
        const added = await this.addRows([{id:this.preview?'home-preview':button.dataset.variant,quantity:1,name:this.strings.home+' · '+this.strings.home_description,price:this.preview?42000:Number(button.dataset.price),eligible:false}]);
        if (added && this.preview && this.mode === 'builder') this.openCart();
      });
      this.backTop = this.querySelector('[data-back-top]');
      this.selectionBar = this.querySelector('[data-selection]');
      this.syncBackTop = () => {
        this.topFrame = 0;
        this.backTop.hidden = window.scrollY < window.innerHeight;
        const selectionBottom = this.selectionBar.hidden ? 0 : Math.max(0,window.innerHeight-this.selectionBar.getBoundingClientRect().top);
        const bottom = Math.max(this.previewHeight || 0,selectionBottom) + 16;
        this.style.setProperty('--uhp-back-top-bottom',bottom+'px');
      };
      this.queueBackTop = () => {
        if (!this.topFrame) this.topFrame = requestAnimationFrame(this.syncBackTop);
      };
      this.backTop.addEventListener('click', () => {
        this.querySelector('[data-top-target]').focus({preventScroll:true});
        window.scrollTo({top:0,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      });
      this.selectionResize = new ResizeObserver(this.queueBackTop);
      this.selectionResize.observe(this.selectionBar);
      window.addEventListener('scroll',this.queueBackTop,{passive:true});
      this.setAttribute('data-top-ready','');
      this.syncPreviewOffset = () => {
        const frame = document.getElementById('PBarNextFrameWrapper') || document.getElementById('PBarNextFrame');
        if (frame && frame !== this.previewFrame) {
          this.previewFrame = frame;
          this.previewResize?.disconnect();
          this.previewResize = new ResizeObserver(this.syncPreviewOffset);
          this.previewResize.observe(frame);
        }
        const r = frame?.getBoundingClientRect();
        const h = r && r.bottom >= window.innerHeight-2 && r.height < 160 ? r.height : 0;
        this.previewHeight = h;
        this.style.setProperty('--uhp-preview-bottom',h+'px');
        this.queueBackTop();
      };
      this.previewObserver = new MutationObserver(this.syncPreviewOffset);
      this.previewObserver.observe(document.body,{childList:true});
      window.addEventListener('resize',this.syncPreviewOffset);
      this.syncPreviewOffset(); this.refresh();
    }
    disconnectedCallback() {this.galleryResize?.disconnect();this.previewObserver?.disconnect();this.previewResize?.disconnect();this.selectionResize?.disconnect();window.removeEventListener('resize',this.syncPreviewOffset);window.removeEventListener('scroll',this.queueBackTop);cancelAnimationFrame(this.topFrame);this.removeAttribute('data-top-ready');}
    format(amount) {return this.money.format(amount/100);}
    status(message) {this.querySelector('[data-status]').textContent = message;}
    cardRow(card,quantity=1) {return {id:card.dataset.variant,quantity,name:card.dataset.name+' · 150 ml',price:Number(card.dataset.price),eligible:true};}
    selectionRows() {return this.cards.map((c,i) => this.cardRow(c,this.counts[i])).filter(r => r.quantity>0);}
    totals(rows) {
      const eligible = rows.reduce((n,r) => n+(r.eligible?r.quantity:0),0);
      const saving = Math.max(0,Math.min(eligible,3)-1)*6100;
      return {count:rows.reduce((n,r)=>n+r.quantity,0),saving,total:rows.reduce((n,r)=>n+r.quantity*r.price,0)-saving};
    }
    addRows(rows) {
      if (!this.preview) return this.submitLiveRows(rows);
      rows.forEach(r => {
        if (!r.id || r.quantity < 1) return;
        const previous = this.cart.get(r.id);
        this.cart.set(r.id,{...r,quantity:r.quantity+(previous?.quantity || 0)});
      });
      this.status(this.strings.added.replace('[name]',rows.map(r=>r.quantity+' × '+r.name).join(', ')));
      this.refresh();
      return true;
    }
    async submitLiveRows(rows) {
      if (this.busy) return false;
      const items = rows.map(row => ({id:Number(row.id),quantity:Number(row.quantity)}));
      if (!items.length || items.some(item => !Number.isSafeInteger(item.id) || item.id < 1 || !Number.isSafeInteger(item.quantity) || item.quantity < 1)) {
        this.showCartError(this.strings.unavailable);
        return false;
      }
      this.busy = true;
      const buttons = [...this.querySelectorAll('[data-direct-add], [data-primary-action], [data-single], [data-warm-duo], [data-home], [data-confirm-size], [data-open-size], [data-step]')];
      const previousStates = buttons.map(button => button.disabled);
      buttons.forEach(button => button.disabled = true);
      this.setAttribute('aria-busy','true');
      this.querySelector('[data-cart-recovery]').hidden = true;
      this.status(this.strings.adding);
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(),20000);
      let redirected = false;
      try {
        const response = await fetch(this.dataset.addUrl + '.js', {
          method:'POST',
          credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items}),
          signal:controller.signal
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400 || !Array.isArray(result.items)) {
          this.showCartError(typeof result.description === 'string' ? result.description : this.strings.cart_error);
          return false;
        }
        window.location.assign(this.dataset.cartUrl);
        redirected = true;
        return true;
      } catch {
        this.showCartError(this.strings.cart_error);
        return false;
      } finally {
        clearTimeout(timeout);
        if (!redirected) {
          this.busy = false;
          this.removeAttribute('aria-busy');
          buttons.forEach((button,index) => button.disabled = previousStates[index]);
        }
      }
    }
    showCartError(message) {
      this.status(message + ' ' + this.strings.check_cart);
      this.querySelector('[data-cart-recovery]').hidden = false;
      const status = this.querySelector('[data-status]');
      status.focus({preventScroll:true});
      status.scrollIntoView({block:'center',behavior:'auto'});
    }
    refresh() {
      const selection = this.selectionRows();
      const picking = this.mode==='builder' && selection.length>0;
      const rows = picking?selection:[...this.cart.values()];
      const t = this.totals(rows);
      this.cards.forEach((c,i) => {
        const output = c.querySelector('[data-count]');
        if (output) {
          output.textContent=this.counts[i];
          c.querySelector('[data-step="-1"]').disabled=this.counts[i]===0;
          c.querySelector('[data-step="1"]').disabled=this.counts.reduce((a,n)=>a+n,0)>=3 || c.dataset.available!=='true';
        }
        const badge = c.querySelector('[data-added]');
        if (badge) {
          const n=[...this.cart.values()].filter(r=>i===0?this.warmIds.includes(r.id):r.id===c.dataset.variant).reduce((a,r)=>a+r.quantity,0);
          badge.hidden=n===0;badge.textContent=this.strings.in_cart.replace('[count]',n);
        }
      });
      this.querySelector('[data-selection]').hidden=t.count===0;
      this.querySelector('[data-selected-summary]').textContent=(picking?this.strings.selected:this.strings.cart_count).replace('[count]',t.count);
      this.querySelector('[data-selected-price]').textContent=this.format(t.total);
      const saving=this.querySelector('[data-savings]'); saving.textContent=t.saving?this.strings.save.replace('[amount]',this.format(t.saving)):''; saving.hidden=!t.saving;
      this.querySelector('[data-primary-action]').textContent=picking?this.strings.add_selection.replace('[count]',t.count):this.strings.view_cart;
      this.syncPreviewOffset?.();
    }
    openCart() {
      if (!this.preview) {window.location.assign(this.dataset.cartUrl);return;}
      this.renderCart();if (!this.cartDialog.open) this.cartDialog.showModal();
    }
    renderCart() {
      const rows=[...this.cart.values()];
      const list=this.querySelector('[data-cart-items]'); list.replaceChildren();
      if (!rows.length) {const p=document.createElement('p');p.textContent=this.strings.empty;list.append(p);}
      rows.forEach(r => {
        const row=document.createElement('div');row.className='uhp-ui__cart-row';row.dataset.cartRow=r.id;
        const info=document.createElement('div');const title=document.createElement('strong');title.className='uhp-ui__cart-name';title.textContent=r.name;
        const price=document.createElement('span');price.className='uhp-ui__cart-unit';price.textContent=this.format(r.price)+' × '+r.quantity;
        info.append(title,price);row.append(info);
        const stepper=document.createElement('div');stepper.className='uhp-gels__stepper';
        const output=document.createElement('output');output.textContent=r.quantity;
        [-1,1].forEach(step=>{
          const b=document.createElement('button');b.type='button';b.textContent=step<0?'−':'+';
          b.dataset.cartStep=String(step);b.setAttribute('aria-label',(step<0?this.strings.remove:this.strings.add).replace('[name]',r.name));
          b.addEventListener('click',()=>{
            const current=this.cart.get(r.id);if (!current) return;
            if (current.quantity+step<=0) this.cart.delete(r.id);else this.cart.set(r.id,{...current,quantity:current.quantity+step});
            this.refresh();this.renderCart();
            const next=[...this.querySelectorAll('[data-cart-row]')].find(n=>n.dataset.cartRow===r.id)?.querySelector('[data-cart-step="'+step+'"]');
            (next || this.cartDialog.querySelector('[data-close]')).focus();
          });
          stepper.append(b);if (step<0) stepper.append(output);
        });row.append(stepper);list.append(row);
      });
      const t=this.totals(rows);this.querySelector('[data-dialog-total]').textContent=this.format(t.total);
      const saving=this.querySelector('[data-cart-saving]');saving.hidden=!t.saving;saving.querySelector('strong').textContent='−'+this.format(t.saving);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
